
import { defineComponent, computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { CookieComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const router = useRouter();
    const i18n = useI18n();
    const store = useStore();
    const user =
      CookieComponent.get("userData") != undefined
        ? reactive(JSON.parse(CookieComponent.get("userData") as string))
        : undefined;

    i18n.locale.value = localStorage.getItem("lang")
      ? (localStorage.getItem("lang") as string)
      : "vn";

    const countries = {
      en: {
        flag: require("@/assets/img/united-states.svg"),
        name: "English",
      },
      vn: {
        flag: require("@/assets/img/vietnam.svg"),
        name: "Vietnamese",
      },
    };

    const signOut = () => {
      store
        .dispatch(Actions.LOGOUT)
        .then(() => router.push({ name: "sign-in" }));
    };
    const setLang = (lang) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const currentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };

    const currentLangugeLocale = computed(() => {
      return countries[i18n.locale.value];
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    return {
      signOut,
      setLang,
      currentLanguage,
      currentLangugeLocale,
      countries,
      user,
      translate,
    };
  },
});
